module.exports = __webpack_public_path__ + "static/media/logo-fda.eafb186d.png";